import styled from "styled-components/macro";

export const ImgSpO = styled.img`
  grid-area: spo;
`;

export const SpOTimestamp = styled.div`
  position: absolute;
  top: 9%;
  right: ${({ landscape, setting }) =>
    landscape ? "-4%" : setting ? "9%" : "7%"};

  background: black;
  width: 60px;
  width: ${({ setting }) => (setting ? "40px" : "50px")};
  font-size: 1rem;
  font-size: ${({ landscape, setting }) =>
    landscape ? ".9rem" : setting ? ".6rem" : ".8rem"};
  color: #38d4f0;
  text-align: center;
`;
